import { render, staticRenderFns } from "./AutoSubstitutingReport.vue?vue&type=template&id=84d680fa&scoped=true&"
import script from "./AutoSubstitutingReport.vue?vue&type=script&lang=js&"
export * from "./AutoSubstitutingReport.vue?vue&type=script&lang=js&"
import style0 from "./AutoSubstitutingReport.vue?vue&type=style&index=0&id=84d680fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d680fa",
  null
  
)

component.options.__file = "AutoSubstitutingReport.vue"
export default component.exports